import * as React from 'react';
// import * as PropTypes from 'prop-types';
import { LOGIN_URL, JS_VOID, returnFalse, parseQueryString } from '../../utils/commonUtil';
import { Global } from '../../utils/global';

interface HeaderProps extends React.Props<{}> {
  auth: any;
  authActions: any;
  header: any;
  request_param: any;
  requestParamActions: any;
  location?: any;
  moffAPI: any;
  moffCheck: any;
}

export default class Header extends React.Component<HeaderProps, {}> {

  componentWillMount () {
    let query = parseQueryString(this.props.location.search);
    this.props.requestParamActions.load(Object.assign({}, this.props.location, {search: query}));
  }

  handleSignOut = () => {
    this.props.authActions.signOut();
  }

  // 検索枠の入力で呼ぶ.
  doChange = () => {
    Global.kanaSerach();
  }

  render() {
    if (this.props.header.no_header) {
      return (null);
    }

    return (
      <header>
        { // タイトル
          (() => {
            if (this.props.header) {
              return <h1>{this.props.header.title}</h1>;
            }
            return <h1>モフトレ・ダッシュボード</h1>;
          })()
        }

        { // 戻るボタン
          (() => {
            if (this.props.header) {
              switch (this.props.header.back_type) {
                case 0:
                  return;
                case 1:
                  return <div className="prev">
                    <a
                      href={this.props.moffAPI.Loading ? '#' : LOGIN_URL}
                    >
                      メニューに戻る
                    </a>
                  </div>;
                case 2:
                  let url = '#';
                  if (this.props.moffAPI.Loaded || this.props.moffCheck.Loaded) {
                    url = this.props.header.back_url;
                  }
                  return <div className="prev">
                    <a
                      href={url}
                    >
                      利用者一覧に戻る
                    </a>
                  </div>;
                case 3:
                  return <div className="prev">
                    <a
                      href={this.props.moffAPI.Loading ? '#' : this.props.header.back_url}
                    >
                      管理に戻る
                    </a>
                  </div>;
                default:
                  break;
              }
            }
            return;
          })()
        }

        { // 検索バーの有無
          (() => {
            if (this.props.header) {
              if (this.props.header.is_search) {
                return <div>
                  <div className="search">
                    <dl className="searchBox">
                      <dt><input type="search" onChange={event => this.doChange()} /></dt>
                      <dd><button onClick={returnFalse}><span /></button></dd>
                    </dl>
                  </div>
                  <div className="btnStyle04 filter">
                    <a href={JS_VOID} onClick={returnFalse}>絞り込み</a>
                  </div>
                </div>;
              }
            }

            return;
          })()
        }

        { // ログアウトの有無
          (() => {
            if (this.props.header) {
              if (this.props.header.is_logout) {
                return <div className="settings">
                  <button
                    id="signout"
                    value="signout"
                    onClick={event => this.handleSignOut()}
                  >
                    ログアウト
                  </button>
                </div>;
              }
            }

            return;
          })()
        }
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Header.tsx